<script>
    export let value;
    export let length;
    export let place;

    let selected = 0;


    const services = [
        {
            name: "KOSMETIKA: PRO MLADOU PLEŤ (60 MINUT)",
            description: "<h3>Ošetření problematické mladistvé pleti</h3><p>Odlíčení, čištění peelingem č. 1, peeling č. 2, formování obočí, hloubkové čištění ultrazvukovou špachtlí, maska, dle přání barvení obočí, závěrečné sérum, ošetření bez masáže</p>",
            available: [
                0,
                1
            ],
            length: 60,
            price: 800,
            priceCurrency: " Kč"
        },
        {
            name: "KOSMETIKA: RELAX-IN (90 MINUT)",
            description: "<h3>Ruční ošetření všech typů pleti bez použití přístrojů</h3><p>Odlíčení, tonizace, čištění pleti peelingem, dle přání formování obočí, intenzivní a výživná masáž obličeje a dekoltu, maska, závěrečný krém (ošetření vhodné pro těhotné) </p>",
            available: [
                0,
                1
            ],
            length: 90,
            price: 1000,
            priceCurrency: " Kč"
        },
        {
            name: "KOSMETIKA: OBNOVA DO HLOUBKY (90 MINUT)",
            description: "<h3>Kompletní ošetření všech typů pleti</h3><p>Odlíčení, čištění pěnou, tonizace, peeling, hloubkové + ultrazvukové čištění, formování obočí, depilace, výživná masáž obličeje a dekoltu + ampulka, maska + barvení obočí /dle přání/, závěrečný krém</p>",
            available: [
                0,
                1
            ],
            length: 90,
            price: 1200,
            priceCurrency: " Kč"
        },
        {
            name: "KOSMETIKA: PERFECTION (120 MINUT)",
            description: "<h3>Hloubková, kolagenová, protivrásková péče o zralou pleť</h3><p>Odlíčení, čištění pěnou, aktivní peeling, čisticí kúra + úprava obočí a depilace horního rtu, aktivní sérum, intenzivní protivrásková masáž obličeje a dekoltu + ampulka, kolagenová maska, závěrečné ošetření s kolagenem</p>",
            available: [
                0,
                1
            ],
            length: 120,
            price: 1500,
            priceCurrency: " Kč"
        },
        {
            name: "KOSMETIKA: DE-LUXE (120 MINUT)",
            description: "<h3>Luxusní kompletní ošetření pleti a dekoltu + masáž rukou</h3><p>luxusní anti-age liftingová celková kosmetická péče s úpravou i barvením obočí, intenzivní protivrásková masáž obličeje, rukou i dekoltu</p>",
            available: [
                0,
                1
            ],
            length: 120,
            price: 1800,
            priceCurrency: " Kč"
        },
        {
            name: "KOSMETIKA: PROTIVRÁSKOVÁ MASÁŽ OBLIČEJE A DEKOLTU (40 MINUT)",
            description: "<h3>Protivrásková masáž obličeje a dekoltu</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 60,
            price: 800,
            priceCurrency: " Kč"
        },
        {
            name: "KOSMETIKA: FORMOVÁNÍ A BARVENÍ OBOČÍ (30 MINUT)",
            description: "<h3>Formování a barvení obočí</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 30,
            price: 300,
            priceCurrency: " Kč"
        },
        {
            name: "KOSMETIKA: DEPILACE NOHOU (60 MINUT)",
            description: "<h3>Depilace nohou</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 60,
            price: 800,
            priceCurrency: " Kč"
        },
        {
            name: "KOSMETIKA: DEPILACE PODPAŽÍ (30 MINUT)",
            description: "<h3>Depilace podpaží</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 30,
            price: 300,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: MADEROTERAPIE (60 MINUT)",
            description: "<h3>Anticelulitidová masáž</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 60,
            price: 1200,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: MADEROTERAPIE (90 MINUT)",
            description: "<h3>Anticelulitidová masáž</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 90,
            price: 1500,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: FIT (60 MINUT)",
            description: "<h3>Intenzivní masáž zadní částí těla</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 60,
            price: 1200,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: DE-LUXE (120 MINUT)",
            description: "<h3>Relaxační a výživná celotělová masáž</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 120,
            price: 1800,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: RELAXAČNÍ AROMA MASÁŽ - BYLINKOVÁ (60 MINUT)",
            description: "<h3>Relaxační masáž zadní části těla - Bylinková</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 60,
            price: 1200,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: LOMI-LOMI (60 MINUT)",
            description: "<h3>Havajská masáž</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 60,
            price: 1200,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: LOMI-LOMI (90 MINUT)",
            description: "<h3>Havajská masáž</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 90,
            price: 1500,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: RELAXAČNÍ AROMA MASÁŽ - LEVANDULOVÝ SEN (90 MINUT)",
            description: "<h3>Relaxační aroma masáž Levandulový sen</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 90,
            price: 1500,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: REGENERAČNÍ & RELAXAČNÍ MASÁŽ OBLIČEJE (40 minut)",
            description: "<h3>Masáž obličeje a dekoltu</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 60,
            price: 800,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: SPORTOVNÍ MASÁŽ ZAD A ŠÍJE (40 MINUT)",
            description: "<h3>Sportovní masáž zad a šíje</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 60,
            price: 800,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: MASÁŽ ZAD, ŠÍJE A HORNÍCH KONČETIN (60 MINUT)",
            description: "<h3>Masáž zad, šíje a horních končetin</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 60,
            price: 1200,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: MASÁŽ ZAD, ŠÍJE A ZADNÍ ČÁSTI TĚLA (60 MINUT)",
            description: "<h3>Masáž zad, šíje a zadní části těla</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 60,
            price: 1200,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: MASÁŽ SPORTOVNÍ, KLASICKÁ CELOTĚLOVÁ (90 MINUT)",
            description: "<h3>MASÁŽ SPORTOVNÍ, KLASICKÁ CELOTĚLOVÁ</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 90,
            price: 1500,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: MASÁŽ ZAD LÁVOVÝMI KAMENY (30 MINUT)",
            description: "<h3>Masáž zad lávovými kameny</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 30,
            price: 700,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: MASÁŽ ZADNÍ ČÁSTI TĚLA LAVOVÝMI KAMENY (60 MINUT)",
            description: "<h3>Masáž zadní části těla lávovými kameny</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 60,
            price: 1200,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: LYMFATICKÁ MASÁŽ DOLNÍCH KONČETIN (60 MINUT)",
            description: "<h3>Lymfatická masáž dolních končetin</h3><br><br><br>",
            available: [
                0
            ],
            length: 60,
            price: 800,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: LYMFATICKÁ MASÁŽ CELKOVÁ (90 MINUT)",
            description: "<h3>Lymfatická masáž celková</h3><br><br><br>",
            available: [
                0
            ],
            length: 90,
            price: 1500,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: ANTICELULITIDOVÁ MASÁŽ DOLNÍCH KONČETIN (40 MINUT)",
            description: "<h3>Anticelulitidová masáž dolních končetin</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 60,
            price: 800,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: ANTICELULITIDOVÁ MASÁŽ DOLNÍCH KONČETIN + ZÁBAL (60 MINUT)",
            description: "<h3>Anticelulitidová masáž celková</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 60,
            price: 1100,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: MEDOVÁ DETOXIKAČNÍ MASÁŽ ZAD (30 MINUT)",
            description: "<h3>Medová detoxikační masáž zad</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 30,
            price: 600,
            priceCurrency: " Kč"
        },
        {
            name: "MASÁŽE: PÁROVÁ MASÁŽ (60 MINUT)",
            description: "<h3>Regenerační & relaxační masáž</h3><br><br><br>",
            available: [
                0,
                1
            ],
            length: 60,
            price: 2000,
            priceCurrency: " Kč"
        }
    ];


    $: availableServices = services.filter(
        (service) => Array.isArray(service.available) && service.available.includes(place)
    );

    $: {
        if (availableServices.length === 0) {
            value = "";
            length = undefined;
            selected = 0;
        } else {
            if (selected >= availableServices.length || selected < 0) {
                selected = 0;
            }

            const current = availableServices[selected];
            value = current?.name ?? "";
            length = current?.length ?? undefined;
        }
    }

    function selectService(index) {
        if (!availableServices.length) return;
        const total = availableServices.length;
        selected = ((index % total) + total) % total;
    }

    const nextService = () => selectService(selected + 1);
    const prevService = () => selectService(selected - 1);
</script>

<div class="service-picker">
    <label for="service-select">Vyberte službu</label>
    <select
        id="service-select"
        name="service-select"
        disabled={availableServices.length === 0}
        on:change={(event) => selectService(+event.target.value)}
    >
        {#each availableServices as service, index}
            <option value={index} selected={index === selected}>{service.name}</option>
        {/each}
    </select>

    {#if availableServices.length > 0}
        {#if availableServices[selected]}
            <div class="service-detail">
                <h4>{availableServices[selected].name}</h4>
                <div class="service-description">
                    {@html availableServices[selected].description}
                </div>
                <div class="service-meta">
                    <span>{availableServices[selected].length} min</span>
                    <span>{availableServices[selected].price}{availableServices[selected].priceCurrency}</span>
                </div>
                <div class="service-nav">
                    <button type="button" on:click={prevService} aria-label="Předchozí služba">←</button>
                    <button type="button" on:click={nextService} aria-label="Další služba">→</button>
                </div>
            </div>
        {/if}
    {:else}
        <p class="service-empty">Žádné služby nejsou pro toto místo k dispozici.</p>
    {/if}
</div>

<style>
    .service-picker {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
        width: 100%;
    }

    select#service-select {
        border-radius: 24px;
        padding: 8px 20px;
    }

    .service-detail {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }

    .service-description :global(p) {
        margin: 0 0 0.5rem 0;
    }

    .service-meta {
        display: flex;
        gap: 1rem;
        font-weight: 600;
    }

    .service-nav {
        display: flex;
        gap: 0.5rem;
    }

    .service-nav > button {
        /* border-radius: 999px;
        padding: 6px 14px;
        border: 1px solid #bc9321;
        background: #bc9321;
        color: #fff;
        cursor: pointer; */
    }

    .service-nav > button:hover {
        /* background: none;
        color: #bc9321; */
    }

    .service-empty {
        color: red;
        margin: 0;
    }
</style>
